import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function GSTRatesMaster(props) {
  const [gstRates, setGSTRates] = useState([]);
  const [GSTRateCode, setGSTRateCode] = useState('');
  const [GSTName, setGSTName] = useState('');
  const [GSTPercent, setGSTPercent] = useState('');
  const [CGSTPercent, setCGSTPercent] = useState('');
  const [SGSTPercent, setSGSTPercent] = useState('');
  const [IGSTPercent, setIGSTPercent] = useState('');
  const [Remark, setRemark] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editGSTRateCode, setEditGSTRateCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [gstRatesMasterEntries, setGSTRatesMasterEntries] = useState([]);
  
   const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);  

  useEffect(() => {
    fetchGSTRatesMaster();
  }, []);

  const fetchGSTRatesMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/gstrates');
      setGSTRatesMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1; 
      setGSTRateCode(nextEntryNo);
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };
  
 
  const calculateMaxEntryNo = (entries) => {
  let maxEntryNo = 0;
  for (const entry of entries) {
  if (entry.GSTRateCode > maxEntryNo) {
    maxEntryNo = entry.GSTRateCode;
  }
  }
  return maxEntryNo;
  };

  const addGSTRate = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/gstrates', {
        GSTRateCode,
        GSTName,
        GSTPercent,
        CGSTPercent,
        SGSTPercent,
        IGSTPercent,
        Remark,
        USERID: props.name
      });
      fetchGSTRatesMaster();
      setGSTRateCode('');
      setGSTName('');
      setGSTPercent('');
      setCGSTPercent('');
      setSGSTPercent('');
      setIGSTPercent('');
      setRemark('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateGSTRate = async (GSTRateCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/gstrates/${GSTRateCode}`, {
        GSTRateCode,
        GSTName,
        GSTPercent,
        CGSTPercent,
        SGSTPercent,
        IGSTPercent,
        Remark,
        USERID: props.name
      });
      fetchGSTRatesMaster();
      setGSTRateCode('');
      setGSTName('');
      setGSTPercent('');
      setCGSTPercent('');
      setSGSTPercent('');
      setIGSTPercent('');
      setRemark('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  
  
    const handleDeleteConfirmation = async () => {
      try {
        if (deleteEntryNo) {
          await deleteGSTRate(deleteEntryNo.GSTRateCode);
          setOpenConfirmation(false);
        }
      } catch (error) {
        console.log('Error:', error);
      }
    };

  const deleteGSTRate = async (GSTRateCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/gstrates/${GSTRateCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchGSTRatesMaster();
      }
    } catch (error) {
      console.log('Error:', error); 

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (gstrate) => {
    setFormMode('edit');
    setGSTRateCode(gstrate.GSTRateCode);
    setGSTName(gstrate.GSTName);
    setGSTPercent(gstrate.GSTPercent);
    setCGSTPercent(gstrate.CGSTPercent);
    setSGSTPercent(gstrate.SGSTPercent);
    setIGSTPercent(gstrate.IGSTPercent);
    setRemark(gstrate.Remark);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = gstRates.filter((gstrate) => {
      const GSTRateCode = gstrate.GSTRateCode.toString().toLowerCase();
      const GSTName = gstrate.GSTName.toString().toLowerCase();
      const Remark = gstrate.Remark.toString().toLowerCase();

      return (
        GSTRateCode.includes(searchQuery.toLowerCase()) ||
        GSTName.includes(searchQuery.toLowerCase()) ||
        Remark.includes(searchQuery.toLowerCase())
      );
    });

    setGSTRatesMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, gstRates]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setGSTRates(gstRates);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditGSTRateCode('');
    setGSTRateCode('');
    setGSTName('');
    setGSTPercent('');
    setCGSTPercent('');
    setSGSTPercent('');
    setIGSTPercent('');
    setRemark('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "GSTRateData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>GSTRatesMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="GSTRateCode" style={{ width: '150px', marginRight: '10px' }}>GSTRateCode</label>
            <input
              type="text"
              value={GSTRateCode}
              readOnly
              placeholder="GSTRateCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="GSTName" style={{ width: '150px', marginRight: '10px' }}>GSTName</label>
            <input
              type="text"
              value={GSTName}
              onChange={(e) => setGSTName(e.target.value)}
              placeholder="GSTName"
              style={{ marginBottom: '5px', padding: '5px', width: '20%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="GSTPercent" style={{ width: '150px', marginRight: '10px' }}>GSTPercent</label>
            <input
              type="text"
              value={GSTPercent}
              onChange={(e) => setGSTPercent(e.target.value)}
              placeholder="GSTPercent"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="CGSTPercent" style={{ width: '150px', marginRight: '10px' }}>CGSTPercent</label>
            <input
              type="text"
              value={CGSTPercent}
              onChange={(e) => setCGSTPercent(e.target.value)}
              placeholder="CGSTPercent"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="SGSTPercent" style={{ width: '150px', marginRight: '10px' }}>SGSTPercent</label>
            <input
              type="text"
              value={SGSTPercent}
              onChange={(e) => setSGSTPercent(e.target.value)}
              placeholder="SGSTPercent"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="IGSTPercent" style={{ width: '150px', marginRight: '10px' }}>IGSTPercent</label>
            <input
              type="text"
              value={IGSTPercent}
              onChange={(e) => setIGSTPercent(e.target.value)}
              placeholder="IGSTPercent"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="Remark" style={{ width: '150px', marginRight: '10px' }}>Remark</label>
            <input
              type="text"
              value={Remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Remark"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addGSTRate : () => updateGSTRate(GSTRateCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GSTRateCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GSTName
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  GSTPercent
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  CGSTPercent
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  SGSTPercent
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  IGSTPercent
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Remark
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {gstRatesMasterEntries.map((gstrate) => (
                <tr key={gstrate.GSTRateCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.GSTRateCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.GSTName}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.GSTPercent}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.CGSTPercent}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.SGSTPercent}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.IGSTPercent}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{gstrate.Remark}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(gstrate)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({GSTRateCode: gstrate.GSTRateCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default GSTRatesMaster;
